<template>
  <div class="tw-container">
    <div>
      <bordered-input>
        <template #label>
          <label for="user_search">Mitarbeiterfilter</label>
        </template>

        <template #input>
          <single-select
              v-model.number="selectedUserId"
              :options="users"
              name="user_search"
              placeholder="Nutzer auswählen"
              @change="onSearch">
          </single-select>
        </template>
      </bordered-input>

      <vue-good-table
          :columns="columns"
          :isLoading.sync="isLoading"

          :pagination-options="{
                    enabled: true,
                    perPage: serverParams.perPage,
                    perPageDropdown: [25, 50, 100],
                    dropdownAllowAll: false,
                    jumpFirstOrLast : true,

                    firstLabel : 'Erste Seite',
                    lastLabel : 'Letzte Seite',
                    nextLabel: 'nächste',
                    prevLabel: 'vorherige',
                    rowsPerPageLabel: 'Zeilen pro Seite',
                    ofLabel: 'von'
                }"
          :rows="qualifications"
          :search-options="{
                    enabled: false,
                    externalQuery: selectedUserId
                }"

          :sort-options="{
                    enabled: true,
                    multipleColumns: false,
                }"
          :totalRows="totalRecords"
          mode="remote"
          theme="rocks"

          @on-sort-change="onSortChange"

          @on-search="onSearch"

          @on-page-change="onPageChange"

          @on-per-page-change="onPerPageChange"
      >
        <template slot="loadingContent">
          <div style="
                        display: inline-block;
                        color: white;
                        border: thin solid var(--color-brand-primary);
                        background-color: var(--color-brand-primary);
                        border-radius: 0.25rem;
                        padding: 0.5rem 1rem 0.5rem 1rem;
                        white-space: nowrap;
                    ">
            Lade Daten
          </div>
        </template>

        <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'actions'">
                        <div class="tw-flex">
                            <button type="button" title="Ansehen" class="cu-btn-default-sm tw-mr-1"
                                    @click="showExpandedContent(props.row)">
                                <i class="fa fa-file"></i>
                            </button>

                          <button v-if="canRenewQualifications" class="cu-btn-default-sm tw-mr-1"
                                  title="Aktualisieren"
                                  type="button"
                                  @click="renewRow(props.row)">
                                <i class="fa fa-refresh"></i>
                            </button>

                            <button v-if="canEditQualifications" class="cu-btn-default-sm tw-mr-1" title="Bearbeiten"
                                    type="button"
                                    @click="editRow(props.row)">
                                <i class="fa fa-pencil"></i>
                            </button>

                            <button v-if="canEditQualifications" class="cu-btn-default-sm" title="Löschen" type="button"
                                    @click="deleteRow(props.row)">
                                <i class="fa fa-trash-o"></i>
                            </button>
                        </div>
                    </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table';
import SingleSelect from "../SingleSelect.vue";
import axios from 'axios';
import BorderedInput from '../Redesign/BorderedInput.vue';

export default {
  components: {VueGoodTable, BorderedInput, SingleSelect},
  props: ['canManageQualifications', 'canEditQualifications', 'canRenewQualifications', 'users'],

  data() {
    return {
      isLoading: true,
      columns: [
        {label: 'Mitarbeiter', field: 'coworker_name', thClass: 'tw-whitespace-nowrap',},
        {label: 'Qualifikation', field: 'type_name', thClass: 'tw-whitespace-nowrap',},
        {
          label: 'Gültig ab',
          field: 'valid_from',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd.MM.yyyy',
          thClass: 'tw-whitespace-nowrap',
          tdClass: 'tw-whitespace-nowrap',
        },
        {
          label: 'Nächste Fälligkeit',
          field: 'next_fit',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd.MM.yyyy',
          thClass: 'tw-whitespace-nowrap',
          tdClass: 'tw-whitespace-nowrap',
        },
        {
          label: 'Nächster FIT gebucht',
          field: 'course_booked_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd.MM.yyyy',
          thClass: 'tw-whitespace-nowrap',
          tdClass: 'tw-whitespace-nowrap',
        },
        {label: 'Aktion', field: 'actions', sortable: false, thClass: 'tw-whitespace-nowrap',},
      ],
      qualifications: [], // rows
      totalRecords: 0, //total rows
      selectedUserId: 0,
      serverParams: {
        sort: [],
        search: [],
        page: [],
        perPage: [],
      },
    };
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onSortChange(params) {
      if (params[0].type !== 'asc' && params[0].type !== 'desc') {
        params[0].type = 'asc'; // Standardwert auf "asc" setzen
      }

      this.updateParams({sort: params});
      this.fetchData();
    },

    onSearch(params) {
      this.updateParams({user_id: this.selectedUserId});
      this.fetchData();
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.fetchData();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.fetchData();
    },

    showExpandedContent(row) {
      window.location.href = `/qualification-management/show/${row.id}`;
    },

    editRow(row) {
      window.location.href = `/qualification-management/edit/${row.id}`;
    },

    renewRow(row) {
      window.location.href = `/qualification-management/renew/${row.id}`;
    },

    deleteRow(row) {
      if (confirm('Möchten sie diese Qualifikation wirklich löschen?')) {
        axios
            .delete(`/qualification-management/destroy/${row.id}`)
            .then(response => {
              if (response.data.message) {
                alert(response.data.message);
              }
              this.fetchData();
            });
      }
    },

    fetchData() {
      console.log('mounted');
      axios
          .get(`/qualification-management/overview`, {
            params: this.serverParams,
          })
          .then(response => {
            console.log('response');
            this.totalRecords = response.data.totalRecords;
            this.qualifications = response.data.data;
          });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
